// src/geom/Axis.ts
export enum Axis {
  X = 'x',
  Y = 'y'
}

export function isXAxis(axis: Axis): boolean {
  return axis === Axis.X;
}

export function isYAxis(axis: Axis): boolean {
  return axis === Axis.Y;
}

export function otherAxis(axis: Axis): Axis {
  return axis === Axis.X ? Axis.Y : Axis.X;
}
